import { render, staticRenderFns } from "./ErrorApp.vue?vue&type=template&id=1482bb44&"
import script from "./ErrorApp.vue?vue&type=script&lang=js&"
export * from "./ErrorApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports